<template>
  <div class="page-container">
    <div class="logo-area">
       <img class="logo-1" src="@/assets/images/common/logo_1.jpg" alt="repechage">
       <div class="brand">Repêchage瑞波琴®</div>
    </div>
    <div class="brand-des">美国高端院线级品牌，以全球独家萃取技术，探索海洋美学的奥秘。历经{{years}}年潜心精研，成就海藻护肤的非凡</div>
    <div>
      <el-row :gutter="30">
        <el-col :span="6" :offset="0" v-for="(note, index) in notes" :key="index">
          <div class="news-item" @click="newPage(note.note_url)">
            <img class="note-cover" :src="note.cover_image" referrerpolicy="no-referrer">
            <div class="display-title">
              {{note.title}}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="show-more" @click="goto('https://www.xiaohongshu.com/user/profile/5de07ced000000000100aab7')">访问官方小红书主页 <i class="el-icon-thumb"></i></div>
    <div class="g-page-area">
      <el-pagination @current-change="currentPageChange" :current-page.sync="page" :page-size="8" layout="total, prev, pager, next" :total="total" background></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      notes: [],
      total: 0,
      page: 1
    }
  },
  computed: {
    years () {
      let years = 100
      const d = new Date()
      const year = d.getFullYear()
      years = year * 1 - 1980
      return years
    }
  },
  methods: {
    currentPageChange (page) {
      this.getRedBookData(page)
    },
    getRedBookData (page) {
      const that = this
      that.axios.get('redbook', { params: { page } }).then(function (resp) {
        that.notes = resp.data.notes
        that.total = resp.data.total
      }).catch(function () {
        console.log('发生错误')
      })
    },
    newPage (url) {
      window.open(url)
    },
    goto (url) {
      window.open(url)
    }
  },
  mounted () {
    this.getRedBookData()
  }
}
</script>

<style scoped>
.page-container{
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 10px 50px;
}
.logo-area{
  text-align: center;
}
.logo-1{
  max-width: 160px;
  border-radius: 50%;
}
.brand{
  box-sizing: border-box;
  padding: 10px 0;
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  color: #333;
}
.brand-des{
  box-sizing: border-box;
  padding: 20px 0 100px;
  text-align: center;
  font-size: 17px;
  line-height: 22px;
  color: #333;
}
.news-item{
  margin-bottom: 10px;
  cursor: pointer;
}
.note-cover{
  border-radius: 15px;
  transition: .1s filter;
  filter:none;
  height: 360px;
  width: 100%;
}
.note-cover:hover{
  filter:brightness(60%);
}
.display-title{
  box-sizing: border-box;
  padding: 10px 0;
  font-size: 14px;
  color: #333333;
  height: 70px;
  line-height: 25px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.show-more{
  color: #333;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  padding: 5px 0 20px;
  display: inline-block;
}
</style>
